// import d3 from "d3";
import * as d3 from "d3";
import {
  schemeOranges,
  schemeReds,
  schemeYlOrBr,
  schemeYlGn,
  schemeYlGnBu,
  schemeYlOrRd,
  schemeRdPu,
  schemeBuGn,
  schemeBlues,
  schemeDark2,
  schemeSet1,
  schemeCategory10,
  schemePaired,
  schemeSet3,
  schemeRdYlBu,
  schemeBuPu,
} from "d3";

// import Dark2Bis from "./Dark2Bis";
// import Set1Bis from "./Set1Bis";

// const d3 = require("d3");

/**
 * Schemes support a range of 3 to 9 colors
 * For decile sets (10), to get the 10th value duplicate the middle value.
 */

export const defaultColor = "#069";
export const lightColor = "#f2f2f2";
export const darkColor = "#2f2f2f";
// The values below are the default colors used by Material UI for their <Paper/> component
export const lightColorInt = 255; // "#fff";
export const darkColorInt = 47; // "#424242" ;

export const quantileSize = 10;

// Numeric decile
export const yellow_red = {
  name: "Yellow - Red",
  value: schemeYlOrRd[9].slice(0, 5).concat(schemeYlOrRd[9].slice(4, 9)),
  // ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"]
};
export const yellow_green_blue = {
  name: "Yellow - Green - Blue",
  value: schemeYlGnBu[9].slice(0, 5).concat(schemeYlGnBu[9].slice(4, 9)),
  // ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"]
};
export const yellow_green = {
  name: "Yellow - Green",
  value: schemeYlGn[9].slice(0, 5).concat(schemeYlGn[9].slice(4, 9)),
  // ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"]
};
export const yellow_brown = {
  name: "Yellow - Brown",
  value: schemeYlOrBr[9].slice(0, 5).concat(schemeYlOrBr[9].slice(4, 9)),
  // ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"]
};
export const red_purple = {
  name: "Red - Purple",
  value: schemeRdPu[9].slice(0, 5).concat(schemeRdPu[9].slice(4, 9)),
  // ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"]
};
export const blue_green = {
  name: "Blue - Green",
  value: schemeBuGn[9].slice(0, 5).concat(schemeBuGn[9].slice(4, 9)),
  // ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"]
};
export const blue_purple = {
  name: "Blue - Purple",
  value: schemeBuPu[9].slice(0, 5).concat(schemeBuPu[9].slice(4, 9)),
  // ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"]
};
export const blues = {
  name: "Blues",
  value: schemeBlues[9].slice(0, 5).concat(schemeBlues[9].slice(4, 9)),
  // ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"]
};
export const reds = {
  name: "Reds",
  value: schemeReds[9].slice(0, 5).concat(schemeReds[9].slice(4, 9)),
  // ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"]
};
export const oranges = {
  name: "Oranges",
  value: schemeOranges[9].slice(0, 5).concat(schemeOranges[9].slice(4, 9)),
  // ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"]
};

export const colors = {
  numeric: {
    value: {
      "Yellow to Red": ["#fffb95", schemeReds[9][7]],
      "Yellow to Brown": ["#fffb95", schemeYlOrBr[9][7]],
      "Yellow to Orange": ["#fffb95", schemeOranges[9][7]],
      "Yellow to Green": ["#fffb95", schemeYlGn[9][7]],
      "Yellow to Blue": ["#fffb95", defaultColor],
      "Yellow to Blue (2)": ["#fffb95", schemeYlGnBu[9][7]],
      "Blue to Brown": [defaultColor, schemeReds[9][7]],
      "Red to Blue": [schemeReds[9][7], defaultColor],
    },
    decile: {
      [yellow_red.name]: yellow_red.value,
      [yellow_green_blue.name]: yellow_green_blue.value,
      [yellow_green.name]: yellow_green.value,
      [yellow_brown.name]: yellow_brown.value,
      [red_purple.name]: red_purple.value,
      [blue_green.name]: blue_green.value,
      [blue_purple.name]: blue_purple.value,
      [blues.name]: blues.value,
      [reds.name]: reds.value,
      [oranges.name]: oranges.value,
    },
  },
  factor: {
    value: {
      // "Set1 Bis (9 colors)": Set1Bis,
      // "Dark2 Bis (8 colors)":Dark2Bis,
      "Dark2 (8 colors)": schemeDark2,
      "Set1 (9 colors)": schemeSet1,
      "Category (10 colors)": schemeCategory10,
      "Paired (12 colors)": schemePaired,
      "Set3 (12 colors)": schemeSet3,
      "Red_Yellow_Blue (11 colors)": schemeRdYlBu,
      "Yellow_Red (10 colors)": yellow_red.value,
    },
  },
};

export const colorList = {
  numeric: {
    value: Object.keys(colors.numeric.value),
    decile: Object.keys(colors.numeric.decile),
  },
  factor: {
    value: Object.keys(colors.factor.value),
  },
};

/** Code below: WIP
 *
 * Not working at the moment (14 Oct 2020)
 * - factor color: Red_Yellow_Blue, Yellow_Red
 */

function dataReducer(fn, key, rowId) {
  return function (prev, curr) {
    prev[curr[rowId]] = fn(curr[key]);
    return prev;
  };
}

function colorNumericValues(data, variableName, scheme, rowId) {
  const domain = d3.extent(data, (datum) => datum[variableName]);

  const colorFn_ = d3
    .scaleLinear()
    .domain(domain)
    .range(scheme)
    .interpolate(d3.interpolateLab);

  return data.reduce(dataReducer(colorFn_, variableName, rowId), {});
}

// TODO improve this function
function colorNumericDecile(data, variableName, scheme, rowId) {
  const binSize = Math.round(data.length / quantileSize);
  let currentBin = 0;
  let currentBinSize = 0;
  let lastValue;
  let colorStepValues = [];

  const rows = data.map((d) => ({
    [rowId]: d[rowId],
    [variableName]: d[variableName],
  }));
  rows.sort((a, b) => +a[variableName] - +b[variableName]);
  const res = {};
  rows.forEach((d) => {
    const value = d[variableName];

    if (
      currentBinSize >= binSize &&
      currentBin < quantileSize - 1 &&
      value !== lastValue
    ) {
      currentBin += 1;
      currentBinSize = 0;

      colorStepValues.push((value + lastValue) / 2);
    }

    currentBinSize += 1;
    lastValue = value;
    res[d[rowId]] = scheme[currentBin];
  });

  return res;
}

function colorFactorValues(data, variableName, scheme, rowId) {
  const domain = Array.from(new Set(data.map((d) => d[variableName])));

  const colorFn_ = d3.scaleOrdinal().domain(domain).range(scheme);

  return data.reduce(dataReducer(colorFn_, variableName, rowId), {});
}

/**
 * This function allow you to map the type from any dataset to the right color type.
 * @param {string} type The raw type (dataset)
 */
export const mapColorType = function (type = null) {
  switch (type) {
    case "character":
      return "factor";

    case "numeric":
    case "integer":
    default:
      return "numeric";
  }
};

export const colorFn = function (array, variable, method, schemeName, rowId) {
  // const items = array.map(a => a[variable.name])
  if (schemeName === defaultColor) return;
  const variableType = mapColorType(variable.type);
  try {
    const scheme = colors[variableType][method][schemeName];
    if (
      array.length > 0 &&
      (array[0][variable.name] === null ||
        array[0][variable.name] === undefined)
    )
      throw new Error(
        `The variable "${variable.name}" is not part of the data set`
      );

    if (variableType === "numeric" && method === "value")
      return colorNumericValues(array, variable.name, scheme, rowId);
    else if (variableType === "numeric" && method === "decile")
      return colorNumericDecile(array, variable.name, scheme, rowId);
    else if (variableType === "factor")
      return colorFactorValues(array, variable.name, scheme, rowId);
  } catch (error) {
    console.error(`[${colorFn.name}]`, error);
  }
};

export function toHexColor(r, g = null, b = null, recursive = false) {
  if (r === null)
    throw new Error(`[${toHexColor.name}] First parameter cannot be null`);

  if (isNaN(r))
    throw new Error(`[${toHexColor.name}] First parameter must be a number`);

  if (g !== null && b !== null) {
    if (isNaN(g))
      throw new Error(`[${toHexColor.name}] Second parameter must be a number`);
    if (isNaN(b))
      throw new Error(`[${toHexColor.name}] Second parameter must be a number`);

    return (
      "#" +
      r.toString(16) +
      toHexColor(g, null, null, true) +
      toHexColor(b, recursive, recursive, true)
    );
  }

  if (!recursive) return "#" + r.toString(16).repeat(3);

  return r.toString(16);
}

/*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */

export const getContrast = function (hexcolor) {
  let r;
  let g;
  let b;
  if (hexcolor.substr(0, 4) === "rgb(") {
    const strArr = hexcolor
      .slice(4)
      .split(",")
      .map((d, i) => {
        let trimmedStr = d.trim();
        if (i === 2) trimmedStr = trimmedStr.slice(0, trimmedStr.length - 1);
        return trimmedStr;
      });
    r = parseInt(strArr[0]);
    g = parseInt(strArr[1]);
    b = parseInt(strArr[2]);
  } else {
    // If a leading # is provided, remove it
    if (hexcolor.slice(0, 1) === "#") {
      hexcolor = hexcolor.slice(1);
    }

    // If a three-character hexcode, make six-character
    if (hexcolor.length === 3) {
      hexcolor = hexcolor
        .split("")
        .map(function (hex) {
          return hex + hex;
        })
        .join("");
    }

    // Convert to RGB value
    r = parseInt(hexcolor.substr(0, 2), 16);
    g = parseInt(hexcolor.substr(2, 2), 16);
    b = parseInt(hexcolor.substr(4, 2), 16);
  }
  // Get YIQ ratio
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 128 ? "black" : "white";
};
